import { RequestIndiceInterface } from "interfaces/Indices/indice";
import { useGetIndicesMutation } from "services/indiceServices/indicesServices";
import { setIsLoading, setMessageLoading } from "store";
import {
  onAddLetraSelected,
  onAddLibroIndiceResponse,
  onResetLibroIndice,
} from "store/libroIndice/libroIndiceSlice";
import { useAppDispatch, useAppSelector } from "./reduxHooks";

export const useLibroIndice = () => {
  const { libroIndiceRes, letraSelected } = useAppSelector(
    (state) => state.libroIndice
  );
  const dispatch = useAppDispatch();
  const [getIndiceLibro, responseGetLibroIndice] = useGetIndicesMutation();

  const startGetLibroIndice = (body: RequestIndiceInterface) => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("cargando información"));
    getIndiceLibro(body)
      .unwrap()
      .then(({ data }) => {
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
        dispatch(onAddLibroIndiceResponse(data));
      })
      .catch((err) => {
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
        console.log(err);
      });
  };

  const addLetraSelected = (letra: number) =>
    dispatch(onAddLetraSelected(letra));

  const resetLibroIndice = () => dispatch(onResetLibroIndice())

  return {
    libroIndiceRes,
    letraSelected,
    responseGetLibroIndice,
    addLetraSelected,
    startGetLibroIndice,
    resetLibroIndice
  };
};
